const Ls13DulceSuenos = () => {
    return (
        <div className="container-fluid bg--main ps-0 ps-sm-0 ps-md-0 ps-lg-3">
            <div className="row d-flex p-0">
                <div className="col-sm-12 col-md-8 col-lg-7 col-xl-6">
                    <h1 className='titulo--lesson--color--1'>Dulces sue&ntilde;os</h1>

                    <h1 className="text--subtitulo p-4">Parte I</h1>

                    <div className='container ps-4'>
                        <p className='texto--parrafo'><span className="texto--span">Los beb&eacute;s prematuros duermen por periodos de tiempo m&aacute;s cortos. Ellos se despiertan con mayor frecuencia.</span> Al estar en casa, incluso los beb&eacute;s prematuros deben dormir sobre su espalda (bocarriba). <br /><br />Use un colch&oacute;n firme y del mismo tama&ntilde;o de la cuna con la s&aacute;bana bien templada y evite el uso de elementos blandos dentro de la cuna como juguetes o almohadas. </p>
                    </div>

                    <div className='col d-block d-sm-block d-md-none style--gif-2 background--baby'>
                        <img src="./img/Ls13Baby.gif" className='img--gid-2' />
                        {/* ./img/Ls1Background.png */}
                    </div>

                    <div className='container ps-4 pt-4'>
                        <p className='texto--link'>
                            Adaptado de: Poets CF, von Bodman A. Placing preterm infants for sleep: first prone, then supine. ArchDis Child Fetal Neonatal Ed. 2007;92(5):F331-F332.</p>
                    </div>

                    <h1 className="text--subtitulo p-4">Parte II</h1>

                    <div className='container ps-4'>
                        <p className='texto--parrafo'><span className="texto--span">Los beb&eacute;s prematuros deben dormir en la misma habitaci&oacute;n que sus padres, pero en su propia cuna, y evitar dormir en la misma cama con los padres.</span> <br /><br />Evite cubrir la cabeza y cara del beb&eacute;. Los beb&eacute;s prematuros son muy sensibles al ruido ambiental. Procure mantener muy bajos los niveles de ruido en el ambiente donde vive el beb&eacute;. </p>
                    </div>

                    <div className='container ps-4 pt-4'>
                        <p className='texto--link'>
                            Adaptado de: <a className='texto--link' target='_blank' href='https://www.healthychildren.org/English/ages-stages/baby/sleep/Pages/AParents-Guide-to-Safe-Sleep.aspx'>https://www.healthychildren.org/English/ages-stages/baby/sleep/Pages/AParents-Guide-to-Safe-Sleep.aspx</a></p>
                    </div>

                </div>

                <div className="col-md-4 d-none d-sm-block d-sm-none d-md-block">
                    <img src="./img/Ls13Baby.gif" className='justify-content-start style--image-baby-13' />
                </div>
            </div>
        </div>
    )
}

export default Ls13DulceSuenos;